<template>
<div class="form-group" :data-id="fieldName" :class="{ 's_active' : isActive }">
  <div class="form-control">
    <input type="text" :name=fieldName :ref=fieldName :placeholder=placeholder v-model="fieldVal" @keyup="onChange" @keyup.enter.self="submitForm" autocomplete="off" :tabindex="tabIndex">
  </div>
</div>
</template>

<script>
import EventBus from '../utils/event-bus';

export default {
  name: "InputText",
  data() {
    return {
      fieldVal: '',
      searchDisplay: false
    };
  },
  props: {
    fieldLabel: String,
    fieldName: String,
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    searchId: {
      type: String,
      default: 'main'
    }
  },
  computed: {

    isActive: function() {
      // console.log(this.fieldVal.length > 0);
      return this.fieldVal.length > 0;
    },

    tabIndex: function() {
      if (this.searchId == 'mega') {
        if (this.searchDisplay) {
          return '0';
        } else {
          return '-1';
        }
      } else {
        return '0';
      }
    },

  },
  methods: {

    onChange() {

      EventBus.$emit('SEARCH_UPDATE', this.fieldName, this.fieldVal);

    },

    submitForm() {

      EventBus.$emit('SEARCH_SUBMIT', this.searchId);

    }

  },
  mounted() {

    EventBus.$on('SEARCH_DISPLAY_UPDATE', (searchDisplay) => {
      this.searchDisplay = searchDisplay;
    });

    EventBus.$on('SEARCH_CLEAR', () => {
      this.fieldVal = '';
    });

    if (this.value.length) {
      this.fieldVal = this.value;
    }

    setTimeout(() => {
      EventBus.$emit('SEARCH_UPDATE', this.fieldName, this.fieldVal);
    }, 100);

  }
};
</script>

<style scoped>
</style>